import React, { createContext, useState, useContext } from 'react';

// Create a Context for authentication
const jobDescriptionContext = createContext();

// Custom hook to use authentication context
export const useJobDescriptionAuth = () => {
  return useContext(jobDescriptionContext);
};

// AuthProvider to wrap the application and provide authentication state
export const JobDescriptionAuthProvider = ({ children }) => {
  const isauth = !localStorage.getItem('jobdesctoken');
  const [isJobDescAuthenticated, setIsJobDescAuthenticated] = useState(!isauth);
  const jobDesclogin = () => {
    setIsJobDescAuthenticated(true);
  };

  const jobdesclogout = () => {
    setIsJobDescAuthenticated(false);
  };

  return (
    <jobDescriptionContext.Provider value={{ isJobDescAuthenticated, jobDesclogin, jobdesclogout }}>
      {children}
    </jobDescriptionContext.Provider>
  );
};
